import { FormDoc, User } from '@vyce/core/src/types';
import { AIAnalyticsDialog } from '@vyce/core/src/components/AIAnalitics/AIAnalyticsDialog';

import { useFormAIAnalytics } from '../hooks/useFormAIAnaytics';

interface Props {
  open: boolean;
  onClose: () => void;
  selectedFormForAIAnalytics: FormDoc | null;
  user: User;
  companyId: string;
}
export const FormAIAnalyticsDialog: React.FC<Props> = ({
  open,
  onClose,
  selectedFormForAIAnalytics,
  user,
  companyId,
}) => {
  const {
    loading,
    aiAnalytics,
    progress,
    setProgress,
    focusOfAnalysis,
    setFocusOfAnalysis,
    formSummaryLoading,
    regenerateAIAnalytics,
    handleClose: handleCloseHook,
  } = useFormAIAnalytics({
    open,
    selectedFormForAIAnalytics,
    userId: user.uuid,
    companyId,
  });

  const handleClose = () => {
    onClose();
    handleCloseHook();
  };

  return (
    <AIAnalyticsDialog
      open={open}
      onClose={handleClose}
      resultText={aiAnalytics}
      progress={progress}
      setProgress={setProgress}
      loading={formSummaryLoading || loading}
      regenerateAIAnalytics={regenerateAIAnalytics}
      loadingText={formSummaryLoading ? 'Getting form summary...' : 'Analyzing the answers...'}
      focusOfAnalysis={focusOfAnalysis}
      onFocusOfAnalysisChange={setFocusOfAnalysis}
    />
  );
};
